import { Module } from 'vuex';
import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { RootState } from "@/store/modules/general/types";
import { ARTICULO } from '../ventas/types';


const namespaced = true;

type HisotricoModule = Module<ARTICULO, RootState>;

export const Historico: HisotricoModule = {
    namespaced,
    actions,
    getters,
    mutations,
}